import React from 'react';
import SMStayReservationCalendarBaseView from './SMStayReservationCalendarBaseView';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';

class SMStayReservationCalendarDesktopView extends SMStayReservationCalendarBaseView {

  constructor(props) {
    super(props);
  }

  renderMonthly() {
    let weekDay = 0;
    let rows = [];
    let cols = [];
    let calendars = this.state.isCheckinCalendar ? this.state.checkinCalendars : this.state.checkoutCalendars;
    const monthFirst = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month - 1, 1)));
    const monthLast = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month, 0)));
    const now = new Date();

    calendars.forEach((calendar, index)=>{
      let classes = [];
      const currentDate = new Date(Date.UTC(calendar.year, calendar.month - 1, calendar.day));
      const current = this.toYMD(currentDate);

      let isCurrentMonth = true;

      let checkinAt = null;
      if (this.state.checkinAt) {
        let checkinAtDate = new Date(this.state.checkinAt);
        checkinAt = this.toYMD(checkinAtDate);
      }

      let checkoutAt = null;
      if (this.state.checkoutAt) {
        let checkoutAtDate = new Date(this.state.checkoutAt);
        checkoutAt = this.toYMD(checkoutAtDate);
      }

      if (current < monthFirst) {
        isCurrentMonth = false;
      }
      if (current > monthLast) {
        isCurrentMonth = false;
      }
      if (current == this.toYMD(now)) {
        classes.push("is-today");
      }
      if (this.state.month == calendar.month && this.state.day == calendar.day) {
        classes.push("is-select");
      }
      if (checkinAt && checkinAt == current) {
        classes.push("is-checked is-reserved is-checkin");
      }
      if (checkoutAt && checkoutAt == current) {
        classes.push("is-checked is-reserved is-checkout");
      }
      if (checkinAt < current && current < checkoutAt) {
        classes.push("is-checked is-middle-reserved");
      }

      const key = current;

      if (!isCurrentMonth) {
        classes.push("is-past");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done"></p>
            </div>
          </td>
        );
      }
      else if(calendar.status == SMConst.RoomStatus.Available) {
        const priceSuffix = this.props.isHourly ? "〜" : "";
        const calendarPrice = calendar.is_last_minute_discount
            ? <p className="reserve-period__calendar-price is-discount"><i className="icon-spm-discount fa-lg"></i>{calendar.price_text}{priceSuffix}</p>
            : <p className="reserve-period__calendar-price">{calendar.price_text}{priceSuffix}</p>;

        cols.push(
          <td key={key} className={classes.join(" ")}>
            <a onClick={this.dayDidSelect.bind(this, calendar)} href="#" className="dashboard-calendar__cell-wrap">
              <p className="dashboard-calendar__date">{calendar.day}</p>
              <div className="reserve-period__calendar-content">
                {calendarPrice}
                <p className="reserve-period__calendar-check"><i className="fa fa-check"></i></p>
              </div>
            </a>
          </td>
        );
      }
      else if (calendar.status == SMConst.RoomStatus.Full || calendar.status == SMConst.RoomStatus.Request) {
        classes.push("is-unavailable");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }
      else {
        classes.push("is-closed");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }

      if (cols.length == 7) {
        rows.push(<tr key={rows.length}>{cols}</tr>);
        cols = [];
      }
    });
    rows.push(<tr key={rows.length}>{cols}</tr>);
    return rows;
  }

  renderReserveStay(){
    if (!this.props.plan.has_stay_price) return;

    let checkinText = this.state.checkinAt ? this.toYMD(new Date(this.state.checkinAt),"/") : I18n.t("service.label_000403");
    let checkoutText = this.state.checkoutAt ? this.toYMD(new Date(this.state.checkoutAt),"/") : "-";

    let leftIsCurrentClassName = "";
    let rightIsCurrentClassName = "";

    let leftSettleClassName = "";
    let rightSettleClassName = "";

    if (this.state.isCheckinCalendar) {
      leftIsCurrentClassName = "reserve-type__button reserve-stay__switch is-current";
      leftSettleClassName = "reserve-stay__switch-day";

      rightIsCurrentClassName = "reserve-type__button reserve-stay__switch";
      rightSettleClassName = "reserve-stay__switch-day";
      if (!this.state.checkoutAt) {
        rightIsCurrentClassName += " is-disabled";
      }
      if (this.state.checkinAt && this.state.checkoutAt) {
        leftSettleClassName += " reserve-stay__switch-day-settle";
        rightSettleClassName += " reserve-stay__switch-day-settle";
      }
    } else {
      leftIsCurrentClassName = "reserve-type__button reserve-stay__switch";
      rightIsCurrentClassName = "reserve-type__button reserve-stay__switch is-current";

      leftSettleClassName = "reserve-stay__switch-day reserve-stay__switch-day-settle";

      if (!this.state.checkoutAt) {
        checkoutText = I18n.t("service.label_000403");
      }
      if (checkoutText == "-" || checkoutText == I18n.t("service.label_000403")) {
        rightSettleClassName = "reserve-stay__switch-day";
      } else {
        rightSettleClassName = "reserve-stay__switch-day reserve-stay__switch-day-settle";
      }
    }
    return(
      <div className="reserve-type reserve-stay__type">
        <div onClick={(e) => this.checkinButtonDidClick(e)} className={leftIsCurrentClassName}>
          <strong className="reserve-stay__switch-check">{I18n.t("service.label_000401")}</strong>
          <span className={leftSettleClassName}>{checkinText}</span>
        </div>
        <div onClick={(e) => this.checkoutButtonDidClick(e)} className={rightIsCurrentClassName}>
          <strong className="reserve-stay__switch-check">{I18n.t("service.label_000402")}</strong>
          <span className={rightSettleClassName}>{checkoutText}</span>
        </div>
      </div>
    );
  }

  render() {

    const room = this.props.room;
    const yearText = sprintf("%s年", this.state.year);
    const monthText = sprintf("%s月", this.state.month);
    const timeStyle = {display: "none"};

    let className = "";
    if (this.state.isCheckinCalendar) {
      className += " is-checkin";
    } else {
      className += " is-checkout";
    }

    return(
      <div ref="calendarContainer" className="js-monthly-table__container reserve-card sm-hide__guteter">
        <div className="reserve-card__inner clearfix">
          {this.renderReserveStay()}

          <div className={className}>
            <div className="reserve-period__header">
              <a onClick={(e) => this.prevMonth(e)} href="#" className="reserve-period__header-navi"><i className="fa fa-angle-left"></i></a>
              <h2 className="reserve-period__title">{yearText}<span className="reserve-period__title-month">{monthText}</span></h2>
              <a onClick={(e) => this.nextMonth(e)} href="#" className="reserve-period__header-navi"><i className="fa fa-angle-right"></i></a>
            </div>
            <table ref="monthlyTable" className="js-monthly-table reserve-period__calendar dashboard-calendar__table">
              <tbody>
              <tr>
                <th className="is-holiday">{I18n.t("datetime.Sun")}</th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Mon")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Tue")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Wed")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Thu")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Fri")}</div></th>
                <th className="is-holiday">{I18n.t("datetime.Sat")}</th>
              </tr>
              {this.renderMonthly()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

}
export default SMStayReservationCalendarDesktopView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMStayReservationCalendarDesktopView.jsx